export enum PreviewDataType {
  DATE,
  CURRENCY,
  TEXT,
  STATUS,
  BOOLEAN,
  HTML,
  ARRAY,
  PERCENT,
  DATE_TIME,
  CHECKBOX,
}
